import React, { useContext } from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

import { MyBetsStoreContext } from "@state/context/my-bets/MyBetsStoreContext";
import { Modal } from "@lib/modal";
import CashoutHistoryBody from "./CashoutHistoryBody";
import CloseCashoutHistory from "./CloseCashoutHistory";
import { useFixBody } from "@state/hooks/shared";

export default observer(function CashoutHistoryModal() {
	const store = useContext(MyBetsStoreContext);
	const { t } = useTranslation("mybets");

	useFixBody(true, store?.cashoutStore?.isCashoutHistoryOpen);

	if (
		store == null ||
		!store.cashoutStore?.isCashoutHistoryOpen ||
		store.cashoutStore?.cashoutHistory == null
	) {
		return null;
	}

	return (
		<Modal>
			<div className="popup">
				<div className="popup__card popup__card--lrg">
					<div className="popup__header">
						<div className="popup__title">
							<span className="u-mar--right--micro">
								{t<string>("ITEM.CASHOUT_HISTORY")}:{" "}
							</span>
							<span className="u-mar--right--xsml">
								{t<string>("mybets:CASHOUT.BET_SLIP_NUMBER", {
									0: store.cashoutStore.cashoutHistorySlipId,
								})}
							</span>

							<span
								className={
									"card--bet__status tag tag--base tag--bet tag--bet--" +
									store.cashoutStore.bet?.betStatus?.abrv
								}
							>
								{store.cashoutStore.bet?.betStatus?.name}
								{store.cashoutStore.bet?.isLive && (
									<>
										{" "}
										-{" "}
										{t<string>(
											"ITEM.LIVE_SCORE"
										).toUpperCase()}
									</>
								)}
								{store.cashoutStore.bet?.isBonus && (
									<> ({t<string>("COMMON.BONUS")})</>
								)}
							</span>
						</div>
					</div>
					<CashoutHistoryBody />
					<CloseCashoutHistory />
				</div>
			</div>
		</Modal>
	);
});
